<template>
  <span class="qa-point-progress">
    Точки: {{ progress.done }} из {{ progress.total }}
    <a-popover
      trigger="hover"
      placement="topRight">
      <template #content>
        <div class="qa-point-progress__content">
          <div class="qa-point-progress__heading">
            <span>Комнаты: {{ completed }} из {{ rooms.length }}</span>
            <a-tooltip
              title="Для зачёта точки осмотрите суммарно 30° по горизонтали и вертикали.
Миникарта: серый — не пройдено, жёлтый — частично, зелёный — пройдено.">
              <span>Осмотр точки: 30°</span>
            </a-tooltip>
          </div>
          <div
            ref="roomStrip"
            class="qa-point-progress__rooms"
            tabindex="0"
            role="region"
            aria-label="Комнаты по этажам">
            <div
              v-for="floor in floors"
              :key="floor.index"
              class="qa-point-progress__floor">
              <span
                v-if="floors.length > 1"
                class="qa-point-progress__floor-title">
                Этаж {{ floor.index + 1 }}{{ floor.index === progress.currentFloorIndex ? ' · вы здесь' : '' }}
              </span>
              <a-button
                v-for="room in floor.rooms"
                :key="room.id"
                size="small"
                :type="room.completed ? 'text' : 'default'"
                :aria-label="`${room.name}, этаж ${floor.index + 1}, ${room.done} из ${room.total}`"
                @click="$emit('goto', room)">
                {{ room.completed ? '✓' : '○' }} {{ room.name }} · {{ room.done }}/{{ room.total }}
              </a-button>
            </div>
          </div>
        </div>
      </template>
      <question-circle-outlined
        tabindex="0"
        aria-label="Прогресс комнат и переход к комнате" />
    </a-popover>
  </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

const props = defineProps({ progress: { type: Object, required: true } });
defineEmits(['goto']);
const roomStrip = ref(null);
const rooms = computed(() => props.progress.rooms ?? []);
const completed = computed(() => rooms.value.filter((room) => room.completed).length);
const floors = computed(() => {
  const grouped = new Map();
  rooms.value.forEach((room) => {
    if (!grouped.has(room.floorIndex)) grouped.set(room.floorIndex, []);
    grouped.get(room.floorIndex).push(room);
  });
  return [...grouped].map(([index, floorRooms]) => ({
    index,
    rooms: [...floorRooms].sort((a, b) => Number(a.completed) - Number(b.completed)),
  })).sort((a, b) => {
    if (a.index === props.progress.currentFloorIndex) return -1;
    if (b.index === props.progress.currentFloorIndex) return 1;
    return a.index - b.index;
  });
});
watch(() => props.progress.currentFloorIndex, () => {
  if (roomStrip.value) roomStrip.value.scrollLeft = 0;
}, { flush: 'post' });
</script>

<style scoped>
.qa-point-progress { display: inline-flex; gap: 6px; align-items: center; }
.qa-point-progress__content { width: min(720px, calc(100vw - 48px)); }
.qa-point-progress__heading { display: flex; justify-content: space-between; margin-bottom: 8px; }
.qa-point-progress__rooms { display: flex; gap: 12px; overflow-x: auto; padding-bottom: 8px; }
.qa-point-progress__floor { display: flex; flex-shrink: 0; gap: 8px; align-items: center; }
.qa-point-progress__floor + .qa-point-progress__floor { border-left: 1px solid #d9d9d9; padding-left: 12px; }
.qa-point-progress__floor-title { white-space: nowrap; font-weight: 600; }
</style>
